import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PullNewPage } from './pull-new';
import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  declarations: [PullNewPage],
  imports: [
    IonicPageModule.forChild(PullNewPage),
    ComponentsModule
  ],
})
export class PullNewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/pull/pull-new/pull-new.module.ts